import { useToastStore, type ToastType } from "../../stores/useToastStore";

const TYPE_STYLES: Record<ToastType, React.CSSProperties> = {
  success: {
    borderLeft: "2px solid var(--comp-green)",
    background: "var(--comp-paper)",
  },
  error: {
    borderLeft: "2px solid var(--comp-salmon)",
    background: "var(--comp-paper)",
  },
  info: {
    borderLeft: "2px solid var(--comp-sky)",
    background: "var(--comp-paper)",
  },
};

const TYPE_ICON: Record<ToastType, string> = {
  success: "\u2713",
  error: "\u2717",
  info: "\u2139",
};

const TYPE_ICON_COLOR: Record<ToastType, React.CSSProperties> = {
  success: { color: "var(--comp-green)" },
  error: { color: "var(--comp-salmon)" },
  info: { color: "var(--comp-sky)" },
};

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts);
  const removeToast = useToastStore((s) => s.removeToast);

  if (toasts.length === 0) return null;

  return (
    <div style={styles.container}>
      {toasts.map((toast) => (
        <div
          key={toast.id}
          style={{ ...styles.toast, ...TYPE_STYLES[toast.type] }}
          role="alert"
        >
          <span style={{ ...styles.icon, ...TYPE_ICON_COLOR[toast.type] }}>
            {TYPE_ICON[toast.type]}
          </span>
          <span style={styles.message}>{toast.message}</span>
          <button
            onClick={() => removeToast(toast.id)}
            style={styles.closeBtn}
            aria-label="Dismiss"
          >
            {"\u00d7"}
          </button>
        </div>
      ))}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: "fixed",
    bottom: "var(--space-5)",
    right: "var(--space-5)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-2)",
    zIndex: 9999,
    maxWidth: 380,
  },
  toast: {
    display: "flex",
    alignItems: "center",
    gap: "var(--space-3)",
    padding: "8px 12px",
    borderRadius: "var(--radius-md)",
    border: "1px solid var(--comp-rule)",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    animation: "toast-in 0.25s ease-out",
    minHeight: 36,
  },
  icon: {
    fontSize: 14,
    fontWeight: 700,
    flexShrink: 0,
  },
  message: {
    flex: 1,
    fontFamily: "var(--font-mono)",
    fontSize: 12,
    color: "var(--fg-1)",
    lineHeight: 1.4,
  },
  closeBtn: {
    fontSize: 16,
    fontWeight: 400,
    color: "var(--fg-3)",
    padding: "0 2px",
    lineHeight: 1,
    flexShrink: 0,
    border: "none",
    background: "none",
    cursor: "pointer",
  },
};
